module.exports = __webpack_public_path__ + "img/cloudLoadding.06fe5a2b.png";